<greco-alert [config]="userAlert" style="display: block"></greco-alert>
